import React from 'react';
import { LenderPackageImportResult } from '../../types';

interface LenderPackageResultSummaryProps {
  result: LenderPackageImportResult;
}

/** Presentational summary of a completed lender-package import. */
export const LenderPackageResultSummary: React.FC<LenderPackageResultSummaryProps> = ({ result }) => (
  <div className="rounded-lg bg-emerald-50 border border-emerald-200 px-5 py-4 text-sm text-emerald-800 space-y-1">
    <div>
      <span className="font-semibold text-emerald-700">{result.imported_count}</span>
      <span> packages imported successfully</span>
    </div>
    <div>
      <span className="font-semibold text-slate-700">{result.replaced_count}</span>
      <span className="text-slate-600"> existing packages replaced</span>
    </div>
    <div>
      <span className="font-semibold text-emerald-700">{result.bom_items_count}</span>
      <span> BOM items inserted</span>
    </div>
  </div>
);
